<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Item Classification</h2>
      <v-card class="mt-4">
      <ItemClassification/>
  </v-card>
  </div>
</template>

<script>
import ItemClassification from '@/components/Utils/ItemClassification.vue'
  export default {
    components: {
      ItemClassification
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>